import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../supabaseClient';
import { LogOut } from 'lucide-react';

const AdminPanel = () => {
  const navigate = useNavigate();
  const [cplInput, setCplInput] = useState('');
  const [cplSaving, setCplSaving] = useState(false);

  useEffect(() => {
    loadCpl();
  }, []);

  const loadCpl = async () => {
    const { data } = await supabase
      .from('app_settings')
      .select('value')
      .eq('key', 'meta_cpl')
      .single();
    setCplInput(data?.value ?? '');
  };

  const saveCpl = async (value) => {
    setCplSaving(true);
    try {
      const { error } = await supabase
        .from('app_settings')
        .upsert({ key: 'meta_cpl', value: value || null, updated_at: new Date().toISOString() });
      if (error) throw error;
      setCplInput(value);
    } catch (err) {
      alert('Erro ao guardar: ' + err.message);
    } finally {
      setCplSaving(false);
    }
  };

  const handleLogout = () => {
    sessionStorage.removeItem('admin_authenticated');
    navigate('/dashboard');
  };

  return (
    <div className="min-h-screen bg-background p-4 md:p-8">
      <div className="max-w-3xl mx-auto">
        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-center justify-between mb-8 gap-4">
          <div>
            <h1 className="text-3xl font-bold text-gray-900 mb-2">Painel Admin</h1>
            <p className="text-gray-600">Configurações da plataforma</p>
          </div>
          <button
            onClick={handleLogout}
            className="flex items-center gap-2 px-4 py-2 bg-gray-600 text-white rounded-lg hover:bg-gray-700 transition-colors"
          >
            <LogOut className="w-4 h-4" />
            Sair do Admin
          </button>
        </div>

        {/* CPL Setting */}
        <div className="bg-white rounded-xl shadow-md border border-primary/10 p-6">
          <h2 className="text-lg font-semibold text-gray-900 mb-1">Preço de Leads (Meta CPL)</h2>
          <p className="text-sm text-gray-500 mb-4">
            Preço aplicado = max(CPL × 1.2, €4.00). Deixar vazio cobra o mínimo de €4.
          </p>
          <div className="flex items-center gap-3 flex-wrap">
            <div className="relative">
              <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-500">€</span>
              <input
                type="number"
                min="0"
                step="0.01"
                value={cplInput}
                onChange={e => setCplInput(e.target.value)}
                placeholder="Ex: 10.50"
                className="pl-7 pr-4 py-2 border border-gray-300 rounded-lg text-sm w-36 focus:outline-none focus:ring-2 focus:ring-primary/30"
              />
            </div>
            {cplInput && !isNaN(parseFloat(cplInput)) && (
              <span className="text-sm text-gray-600">
                → Preço por lead: <strong>€{Math.max(parseFloat(cplInput) * 1.2, 4).toFixed(2)}</strong>
              </span>
            )}
            <button
              onClick={() => saveCpl(cplInput)}
              disabled={cplSaving}
              className="px-4 py-2 bg-primary text-white rounded-lg text-sm hover:bg-primary/90 disabled:opacity-50 transition-colors"
            >
              {cplSaving ? 'A guardar...' : 'Guardar'}
            </button>
            <button
              onClick={() => saveCpl('')}
              disabled={cplSaving}
              className="px-4 py-2 bg-gray-200 text-gray-700 rounded-lg text-sm hover:bg-gray-300 disabled:opacity-50 transition-colors"
            >
              Limpar
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminPanel;
